import React, { useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedComplaints, deleteComplaint } from '../../../services/complaintService';
import { Complaint } from '../../../types/complaint';
import { getComplaintColumns } from './ComplaintColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';


interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const ComplaintsListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [complaintToDelete, setComplaintToDelete] = useState<Complaint | null>(null);

  const openDeleteDialog = (complaint: Complaint) => {
    setComplaintToDelete(complaint);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setComplaintToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!complaintToDelete) return;
    const promise = deleteComplaint(complaintToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف الشكوى...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف الشكوى بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف الشكوى.';
      },
    });
  };

  const columns = useMemo(() => getComplaintColumns(openDeleteDialog), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<Complaint>({
    columns,
    fetchData: getPagedComplaints,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة الشكاوى</h1>
      </div>
      <div className={pageStyles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Complaint> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف الشكوى رقم "${complaintToDelete?.id}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default ComplaintsListPage;
